import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "src/components/common/Button";
import styles from "./styles.module.scss";
import { ModalActions } from "src/redux/Modal/actions";
import { SettingsSelectors } from "src/redux/Settings/selectors";
import { SettingsActions } from "src/redux/Settings/actions";
import { AuthSelectors } from "src/redux/Auth/selectors";
import Toggle from "src/components/common/Toggle";

export default () => {
    const dispatch = useDispatch();
    const isTraderRole = useSelector(AuthSelectors.IsTraderRole);
    const userSettings = useSelector(SettingsSelectors.UserSettings);
    const { emailOptIns } = userSettings;
    const {
        "enable-lender-approve-ea-upgrade": enabledLenderApproveEAUpgrade,
        "enable-recall-trade": enabledRecallTrade,
        "limited-ui": limitedUi,
    } = useSelector(SettingsSelectors.FeatureFlags);

    const onEmailOptInsChange = (e) => {
        dispatch(
            SettingsActions.SetUserSettings({
                emailOptIns: {
                    ...emailOptIns,
                    [e.target.name]: e.target.checked,
                },
            })
        );
    };

    return (
        <div className={styles.personalSettings}>
            <div className={styles.section}>
                <div className={styles.title}>Notifications</div>
                <div className={styles.description}>
                    Enable or disable email notifications by event
                </div>
                <div className={styles.toggles}>
                    <Toggle
                        reverseLabel
                        label={limitedUi ? "Requests Received" : "Locates Received"}
                        name="locatesReceived"
                        value={emailOptIns.locatesReceived}
                        dataTestId="toggle-notification-locates"
                        onChange={onEmailOptInsChange}
                    />
                    <Toggle
                        reverseLabel
                        label="Offers Received"
                        name="offersReceived"
                        value={emailOptIns.offersReceived}
                        dataTestId="toggle-notification-offers"
                        onChange={onEmailOptInsChange}
                    />
                    {enabledRecallTrade && (
                        <Toggle
                            reverseLabel
                            label="Recalls Received"
                            name="recallsReceived"
                            value={emailOptIns.recallsReceived}
                            dataTestId="toggle-notification-recalls"
                            onChange={onEmailOptInsChange}
                        />
                    )}
                    <Toggle
                        reverseLabel
                        label="New Inbox Messages"
                        name="newAvailabilityReceived"
                        value={emailOptIns.newAvailabilityReceived}
                        dataTestId="toggle-notification-availability"
                        onChange={onEmailOptInsChange}
                    />
                    {enabledLenderApproveEAUpgrade && (
                        <Toggle
                            reverseLabel
                            label="EA Upgrade Requests"
                            name="eaUpgradeRequestReceived"
                            value={emailOptIns.eaUpgradeRequestReceived}
                            dataTestId="toggle-notification-ea-upgrade"
                            onChange={onEmailOptInsChange}
                        />
                    )}
                </div>
            </div>

            <div key="footer" className={styles.footer}>
                <Button
                    onClick={() => dispatch(ModalActions.Close())}
                    value="Cancel"
                    color="reversedWhite"
                    dataTestId="cancel-user-settings"
                />
                <Button
                    value="Save"
                    disabled={!isTraderRole}
                    onClick={() =>
                        dispatch(
                            SettingsActions.UpdateAndCloseModal(
                                SettingsActions.UpdateUserSettings()
                            )
                        )
                    }
                    dataTestId="save-user-settings"
                />
            </div>
        </div>
    );
};
